// stores/theme.js
import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  // State
  const isDarkMode = ref(false)
  
  // Initialize theme from localStorage or system preference
  function initTheme() {
    const savedTheme = localStorage.getItem('theme')
    
    if (savedTheme) {
      isDarkMode.value = savedTheme === 'dark'
    } else {
      // Check system preference
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      isDarkMode.value = prefersDark
    }
    
    applyTheme(isDarkMode.value)
  }
  
  // Apply theme to document
  function applyTheme(dark) {
    if (dark) {
      document.documentElement.classList.add('dark')
      document.body.classList.add('dark')
      // Set body background
      document.body.style.backgroundColor = '#111827'
      document.body.style.color = '#f3f4f6'
    } else {
      document.documentElement.classList.remove('dark')
      document.body.classList.remove('dark')
      document.body.style.backgroundColor = '#f9fafb'
      document.body.style.color = '#111827'
    }
    
    localStorage.setItem('theme', dark ? 'dark' : 'light')
  }
  
  // Toggle theme
  function toggleTheme() {
    isDarkMode.value = !isDarkMode.value
    applyTheme(isDarkMode.value)
  }
  
  // Watch for changes
  watch(isDarkMode, (newValue) => {
    applyTheme(newValue)
  })
  
  return {
    isDarkMode,
    initTheme,
    toggleTheme
  }
})